<template>
  <div class="video-entry">
    <Button
      class='button'
      :disabled="isDisabled"
      v-bind:class="{ entrySelected: collectionName === selectedEntry }"
      @click="sendlink(collectionTitle)"
    >
      <p class="collection-entry">
        {{ collectionShortName }}
      </p>

    </Button>
    <div class="devider"></div>
  </div>
</template>

<script>
import '../compiled-icons/star'
/* import axios from 'axios' */

export default {
  name: 'Header',
  props: [
    'collectionName',
    'selectedEntry',
    'collectionTitle'
  ],
  data () {
    return {
      listEntry: this.collectionName.split('exported_data_')[1],
      selectedVodProvider: '',
      exportType: '',
      collectionShortName: '',
      isDisabled: false
    }
  },
  mounted () {
    console.log(' ========> getting provider of ' + this.collectionName.split(' ')[0])
    this.collectionShortName = this.collectionName
    if (this.collectionName.includes('🔒')) {
      this.isDisabled = true // ToDo don't comment out on production!
      console.log('setting to true')
    } else {
      console.log('setting to false')
    }
    /* let getProviderUrl = 'http://vod-qa-dashboard.mixd.tv:3000/getExportProvider/' + this.collectionName

    this.collectionShortName = this.collectionName.split('_')[2].split('T')[0] + ' #' + this.collectionTitle.split('#')[1]
    // this.collectionShortName = this.collectionTitle //collectionName.split('_')[2].split('T')[0] + '#' + this.collectionName.split('#')[1]

    axios.get(getProviderUrl).then(response => {
      this.selectedVodProvider = response.data.msg.provider
      this.exportType = response.data.msg.type
    }) */
  },
  watch: {
    collectionName: function (val) {
      this.collectionName = val
    }
  },
  methods: {
    sendlink: function (taitem) {
      console.log('Click1')
      this.$emit('selected-link', taitem)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-entry {
  color: #000;
  margin-bottom: 1px;
  display: flex;
}
.button{
  border: 0px;
  width: 100%
}
.button:hover {
  background-color: #aaa;
}
.button:disabled {
  background-color: #bbb;
}
.entrySelected {
  background-color: rgba(255,255,255,0.6);
  box-shadow: inset 0 0 1px #000000;
  border: 0px;
  margin: 0px;
  outline:0;
}
.collection-entry {
  text-transform: capitalize;
  text-align: left;
  padding-top: 3px;
  padding-left: 5px;
  padding-right: 5px;
  margin-bottom: 0px;
  color: #333;
  font-size: 10px;
  font-weight: bold;
  max-height: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
}

.devider{
  height: 1px;
  margin-left: 0px;
  margin-right: 0px;
  background-color: #bbb;
}

</style>



// WEBPACK FOOTER //
// src/components/ListTextEntry.vue